import { inject, Pipe, type PipeTransform } from '@angular/core';
import type { MainMenuItem } from './main-menu-config.type';
import { AUTH_SERVICE_INJECTION_TOKEN } from '@szte-griffin/core/auth/ui';
import type { AdminUserRole } from '@cappus/shared-common';

@Pipe({
  name: 'filterMenuItemsByRole',
})
export class FilterMenuItemsByRolePipe implements PipeTransform {
  readonly #authService = inject(AUTH_SERVICE_INJECTION_TOKEN);
  transform(mainMenuItems: MainMenuItem<AdminUserRole>[]): MainMenuItem<AdminUserRole>[] {
    return mainMenuItems.filter(item => this.#authService.hasRealmRole(item.role));
  }
}
